import { useApi } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, toValue } from "vue";

export function usePageCollections(options?: {
  search?: Ref<string> | string;
  page?: Ref<number> | number;
  perPage?: number;
}) {
  const api = useApi();

  const search = computed(() => toValue(options?.search) || "");
  const page = computed(() => toValue(options?.page) || 1);
  const perPage = computed(() => options?.perPage || 15);

  const query = useQuery({
    queryKey: computed(() => [
      "admin",
      "page-collections",
      {
        search: search.value,
        page: page.value,
        per_page: perPage.value,
      },
    ]),
    queryFn: () => api.admin.pages.listCollections({
      query: {
        search: search.value || undefined,
        page: page.value,
        per_page: perPage.value,
      },
    }),
    staleTime: 60 * 1000,
  });

  return {
    collections: computed(() => query.data.value?.data || []),
    pagination: computed(() => query.data.value?.pagination),
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
